export const transformCollection = collection => ({
  id: collection.id,
  isActive: collection.is_active,
  humanizedDiscountAmount: collection.humanized_discount_amount,
  title: collection.title,
  itemsPhotos: collection.items_photos,
  itemsCount: collection.items_count
});
export const transformCollections = dto => ({
  humanizedTimeLeft: dto.humanized_time_left,
  maxActiveCount: dto.max_active_count,
  maxTotalCount: dto.max_total_count,
  collections: dto.collections.map(transformCollection)
});